import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(source, true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(source)).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import types from 'prop-types';
import { compose, mapProps, setDisplayName } from 'recompose';

var WithCosmetic = function WithCosmetic(_ref) {
  var cosmetic = _ref.cosmetic,
      styles = _ref.styles,
      meta = _ref.meta,
      setRef = _ref.setRef,
      props = _objectWithoutProperties(_ref, ["cosmetic", "styles", "meta", "setRef"]);

  return React.createElement("div", styles('cosmeticWrapper'), React.createElement("input", _extends({}, props, {
    ref: setRef
  })), cosmetic && React.createElement("div", styles('cosmetic'), cosmetic));
};

export default compose(setDisplayName('behaviour(Cosmetic)'), mapProps(function (_ref2) {
  var cosmetic = _ref2.cosmetic,
      placeholder = _ref2.placeholder,
      props = _objectWithoutProperties(_ref2, ["cosmetic", "placeholder"]);

  return _objectSpread({}, props, {}, cosmetic ? {
    cosmetic: cosmetic
  } : {}, {
    placeholder: cosmetic ? '' : placeholder,
    Input: WithCosmetic
  });
}));
export var propTypes = {
  cosmetic: types.element
};